import initQtyPricingPopover from "components/jiffy/product-card/quantity-price-popover/quantity-price-popover";
import { track } from "jiffy-analytics";
import initColorSelector from "./color-swatch/color-swatch";

class ProductCardV3 {
  #$productCards;

  constructor($productCards) {
    if ($productCards && (Array.isArray($productCards) || $productCards instanceof NodeList)) {
      this.#$productCards = Array.from($productCards);
    } else {
      this.#$productCards = [];
    }
  }

  initialize() {
    if (!this.#$productCards || !this.#$productCards.length) return;
    this.#$productCards.forEach($productCard => {
      ProductCardV3.initProductCardClickHandler($productCard);
      initQtyPricingPopover($productCard);
      initColorSelector($productCard);
    });
  }

  static initProductCardClickHandler($productCard) {
    $productCard.addEventListener("click", e => {
      const { color } = e.target.dataset;

      if (e.target.classList.contains("js-start-designing")) return;

      track("product_clicked", {
        ...JSON.parse($productCard.dataset.mixpanelData),
        ...(color ? { color } : {})
      });
    });
  }
}

export default $productCards => new ProductCardV3($productCards).initialize();
